import { useEffect, useState } from 'react';

function readHeaderInset(): number {
  const header = document.querySelector('[data-testid="app-header"]');
  let headerHeight = 0;
  if (header instanceof HTMLElement) {
    const mobilePill =
      header.classList.contains('app-header--mobile-pill') &&
      window.matchMedia('(max-width: 48rem)').matches;
    if (!mobilePill) {
      headerHeight = header.getBoundingClientRect().height;
    }
  } else {
    headerHeight =
      Number.parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--size-app-header'),
      ) || 0;
  }

  return headerHeight;
}

/** True once an anchor has scrolled above the sticky header. */
export function useScrollPastHeaderAnchor(anchorTestId: string, enabled = true): boolean {
  const [past, setPast] = useState(false);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const found = document.querySelector(`[data-testid="${anchorTestId}"]`);
    if (!(found instanceof HTMLElement)) {
      return undefined;
    }
    const anchor: HTMLElement = found;

    function update() {
      const { top, bottom } = anchor.getBoundingClientRect();
      const onScreen = bottom > 0 && top < window.innerHeight;
      if (onScreen) {
        setPast(false);
        return;
      }

      setPast(bottom <= readHeaderInset());
    }

    update();

    window.addEventListener('scroll', update, { passive: true });
    window.visualViewport?.addEventListener('resize', update);
    window.addEventListener('resize', update);

    const observer = new ResizeObserver(update);
    observer.observe(anchor);
    const header = document.querySelector('[data-testid="app-header"]');
    if (header instanceof HTMLElement) {
      observer.observe(header);
    }

    return () => {
      window.removeEventListener('scroll', update);
      window.visualViewport?.removeEventListener('resize', update);
      window.removeEventListener('resize', update);
      observer.disconnect();
    };
  }, [anchorTestId, enabled]);

  return enabled && past;
}
